// TV Planning API — all calls go to /api/tv
const BASE = '/api/tv';

function getToken() { return localStorage.getItem('plan_token'); }

async function request(method, path, body) {
  const headers = { 'Content-Type': 'application/json' };
  const token = getToken();
  if (token) headers['Authorization'] = `Bearer ${token}`;
  const res = await fetch(`${BASE}${path}`, {
    method, headers,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  if (res.status === 401) {
    localStorage.removeItem('plan_token');
    window.location.href = '/login';
    return;
  }
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `HTTP ${res.status}`);
  return data;
}

export const tvApi = {
  // Auth
  login:          (email, password)   => request('POST', '/auth/login', { email, password }),
  me:             ()                  => request('GET',  '/auth/me'),
  changePassword: (old_pw, new_pw)    => request('POST', '/auth/change-password', { old_password: old_pw, new_password: new_pw }),

  // Users
  getUsers:       ()                  => request('GET',  '/users'),
  createUser:     (data)              => request('POST', '/users', data),
  updateUser:     (id, data)          => request('PUT',  `/users/${id}`, data),
  deleteUser:     (id)                => request('DELETE',`/users/${id}`),
  resetPassword:  (id, pw)            => request('POST', `/users/${id}/reset-password`, { new_password: pw }),

  // Clients
  getClients:     ()                  => request('GET',  '/clients'),
  createClient:   (data)              => request('POST', '/clients', data),
  updateClient:   (id, data)          => request('PUT',  `/clients/${id}`, data),
  deleteClient:   (id)                => request('DELETE',`/clients/${id}`),

  // Plans
  getPlans:       (clientId)          => request('GET',  `/plans/client/${clientId}`),
  getPlan:        (id)                => request('GET',  `/plans/${id}`),
  createPlan:     (data)              => request('POST', '/plans', data),
  savePlan:       (id, data)          => request('PUT',  `/plans/${id}`, data),
  submitPlan:     (id)                => request('POST', `/plans/${id}/submit`),
  approvePlan:    (id, comment)       => request('POST', `/plans/${id}/approve`, { comment }),
  rejectPlan:     (id, comment)       => request('POST', `/plans/${id}/reject`,  { comment }),
  archivePlan:    (id)                => request('POST', `/plans/${id}/archive`),
  addComment:     (id, text)          => request('POST', `/plans/${id}/comments`, { text }),
  getVersions:        (id)            => request('GET',  `/plans/${id}/versions`),
  getPlanVersions:    (id)            => request('GET',  `/plans/${id}/versions`),
  resolveComment:     (planId, cId)   => request('POST', `/plans/${planId}/comments/${cId}/resolve`),
  getClient:          (id)            => request('GET',  `/clients/${id}`),
};

// Alias for backwards compatibility
export const api = tvApi;
